import { render, staticRenderFns } from "./ubcTitrationReportSheet1.vue?vue&type=template&id=2923ea0a&"
import script from "./ubcTitrationReportSheet1.vue?vue&type=script&lang=js&"
export * from "./ubcTitrationReportSheet1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VFileInput,VSimpleTable})
